<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-select
          v-model="location_type"
          style="width:200px"
          class="handle-select mr10"
          @change="selectHandle"
        >
          <el-option
            v-for="(child, index) in location_types"
            :key="index"
            :label="child.label"
            :value="child.value"
          ></el-option>
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-lx-add"
          class="handle-add"
          @click="addEdit"
          >新增</el-button
        >
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + page_index }}</span>
          </template>
        </el-table-column>
        <el-table-column label="封面" align="center" width="200">
          <template slot-scope="scope">
            <el-image
              class="table-td-thumb"
              :src="scope.row.img_url"
              :preview-src-list="[scope.row.img_url]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="标题"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sub_title"
          label="副标题"
          width="100"
          align="center"
          v-if="location_type == 2"
        ></el-table-column>
        <el-table-column label="类型" align="center" v-if="location_type == 2">
          <template slot-scope="scope">
            {{ topicsType(scope.row.term_id) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="url"
          label="路径"
          align="center"
          v-if="location_type != 2"
        >
          <template slot-scope="scope">
            {{ scope.row.url }}
          </template>
        </el-table-column>
        <el-table-column
          prop="route_path"
          label="路由地址"
          align="center"
          v-if="location_type == 3"
        ></el-table-column>
        <el-table-column label="启用状态" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.enable">已启用</el-tag>
            <el-tag type="danger" v-else>未启用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="日期" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.enable"
              type="text"
              icon="el-icon-edit"
              @click="enableEdit(scope.row)"
              >不启用</el-button
            >
            <el-button
              v-else
              type="text"
              icon="el-icon-edit"
              @click="enableEdit(scope.row)"
              >启用</el-button
            >
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
              >修改</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="类型：" v-show="!is_add">
          <span class="fc">{{ locationTypes(form.location_type) }}</span>
        </el-form-item>
        <el-form-item
          label="专题类型："
          v-show="!is_add && form.location_type == 2"
        >
          <span class="fc">{{ topicsType(form.term_id) }}</span>
        </el-form-item>
        <el-form-item label="标题：" prop="name">
          <el-input v-model="form.name" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item label="类型：" prop="location_type" v-show="is_add">
          <el-select v-model="form.location_type" class="handle-select">
            <el-option
              v-for="(child, index) in location_types"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封面：" prop="img_path">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="form.img_path"
              :src="form.img_path"
              class="avatar"
              alt="加载失败"
            />
            <em
              v-show="!form.img_path && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="专题类型："
          prop="term_id"
          v-show="is_add && form.location_type == 2"
        >
          <el-select v-model="form.term_id" class="handle-select">
            <el-option
              v-for="(child, index) in topics_type"
              :key="index"
              :label="child.name"
              :value="child.term_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="副标题："
          prop="sub_title"
          v-show="form.location_type == 2"
        >
          <el-input v-model="form.sub_title" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item
          label="路径："
          prop="url"
          v-show="form.location_type != 2"
        >
          <el-input v-model="form.url" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item
          label="路由地址："
          prop="route_path"
          v-show="form.location_type == 3"
        >
          <el-input v-model="form.route_path" @input="onInput()"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm')"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import http from "../../../api/hemeraApiConfig";
import http2 from "../../../api/uploadApiConfig";
export default {
  name: "Pagemanage",
  data() {
    return {
      location_types: [
        // {"label": "健康服务", "value": 1},
        { label: "健康专题", value: 2 },
        { label: "健康评估", value: 3 },
      ],
      location_type: 2,
      topics_type: [],
      tableData: [],
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 10,
      loading: false,
      imageUrl: "",
      multipleSelection: [],
      delList: [],
      editVisible: false,
      is_add: false,
      uploading: false,
      form: {},
      submit_obj: {},
      rules: {
        name: [{ required: true, message: "请填写标题", trigger: "blur" }],
        img_path: [{ required: true, message: "请上传封面", trigger: "blur" }],
        url: [{ required: true, message: "请填写路径", trigger: "blur" }],
        term_id: [
          { required: true, message: "请选择专题类型", trigger: "blur" },
        ],
        sub_title: [
          { required: true, message: "请填写副标题", trigger: "blur" },
        ],
        route_path: [
          { required: true, message: "请填写路由地址", trigger: "blur" },
        ],
      },
      idx: -1,
      id: -1,
    };
  },
  created() {
    let that = this;
    this.getData();
    http.get("admin/health/topics").then(function(res) {
      that.topics_type = res.data.data;
    });
  },
  methods: {
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    locationTypes(id) {
      var item = _.filter(this.location_types, function(selector) {
        return selector.value == id;
      })[0];
      if (item) {
        return item["label"];
      } else {
        return "";
      }
    },
    topicsType(id) {
      var item = _.filter(this.topics_type, function(selector) {
        return selector.term_id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
      };
      params["type"] = that.location_type;
      http.get("admin/health", { params: params }).then(function(res) {
        that.page_index = (that.currentPage - 1) * that.page_size;
        that.tableData = res.data.data;
        that.currentPage = 1;
        that.totalPages = res.data.data.total_pages;
        that.pageTotal = that.totalPages * that.page_size;
        that.loading = false;
      });
    },
    //选择
    selectHandle() {
      this.currentPage = 1;
      this.getData();
    },
    // 触发搜索按钮
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    //启用操作
    enableEdit(row) {
      // 二次确认删除
      let that = this;
      let params = {
        type: row.type,
        name: row.name,
        img_path: row.img_path,
        url: row.url,
        sub_title: row.sub_title,
        term_id: row.term_id,
        route_path: row.route_path,
      };
      if (row.enable) {
        params["enable"] = 0;
        that
          .$confirm("是否关闭启用?", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("admin/health/" + row.id, params).then(function(res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("关闭成功");
                that.getData();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      } else {
        params["enable"] = 1;
        that
          .$confirm("是否启用?", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("admin/health/" + row.id, params).then(function(res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("启用成功");
                that.getData();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    beforeAvatarUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", "common/findpage");
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        http2.post("upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.imageUrl = "common/findpage/" + filename;
            that.form.img_path = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 删除操作
    handleDelete(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("admin/health/" + row.id).then(function(res) {
            // console.log(res);
            if (res.data.status_code == 200) {
              that.$message.success("删除成功");
              that.getData();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 多选操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onInput() {
      this.$forceUpdate();
    },
    // 编辑操作
    handleEdit(row) {
      this.form = {
        id: row.id,
        enable: row.enable,
        location_type: this.location_type,
        name: row.name,
        img_path: row.img_url,
        url: row.url,
        term_id: row.term_id,
        sub_title: row.sub_title,
        route_path: row.route_path,
      };
      this.imageUrl = row.img_path;
      this.is_add = false;
      this.editVisible = true;
    },
    //新增操作
    addEdit() {
      this.form = {
        enable: 0,
        location_type: this.location_type,
        name: "",
        img_path: "",
        url: "",
        term_id: 81,
        sub_title: "",
        route_path: "",
      };
      this.is_add = true;
      this.editVisible = true;
    },
    // 保存编辑
    saveEdit(formName) {
      let that = this;
      if (that.location_type == 2) {
        that.form.url = "url";
      } else {
        that.form.term_id = 0;
        that.form.sub_title = "sub_title";
      }
      if (that.location_type != 3) {
        that.form.route_path = "route_path";
      }
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            type: that.location_type,
            enable: that.form.enable,
            name: that.form.name,
            img_path: that.imageUrl,
            url: that.form.url,
            term_id: that.form.term_id,
            sub_title: that.form.sub_title,
            route_path: that.form.route_path,
          };
          if (that.is_add) {
            http.post("admin/health", params).then(function(res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success(`新增成功`);
                that.getData();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          } else {
            http
              .put("admin/health/" + that.form.id, params)
              .then(function(res) {
                // console.log(res);
                if (res.data.status_code == 200) {
                  that.$message.success(`修改成功`);
                  that.getData();
                } else {
                  that.$message.error(res.data.msg);
                }
              });
          }
          that.editVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 180px;
}
.self-dialog-footer {
  display: block;
  text-align: center;
}
.avatar {
  height: 178px;
  display: block;
  max-width: 100%;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
